import { createAsyncThunk } from '@reduxjs/toolkit'
import { getSpotFeeRates, TradingFeeRates } from '../../../api/v1/spot'
import Decimal from 'decimal.js'

export const getSpotFeeRatesAction = createAsyncThunk<TradingFeeRates>(
  'spot/getSpotFeeRatesAction',
  async () => {
    const r = await getSpotFeeRates()
    const { data } = r
    data.maker = Decimal.mul(data.maker, 10000).toNumber()
    data.taker = Decimal.mul(data.taker, 10000).toNumber()
    return r.data
  },
)
